import {
  INPUT_DOC_LENS_ANALYSIS,
  INPUT_DOC_LENS_CASHFLOW,
  INPUT_DOC_LENS_GROSS_MARGIN_LEGACY,
  INPUT_DOC_LENS_MARGIN_BREAK_EVEN,
  INPUT_DOC_LENS_SUMMARY_2,
} from 'constants/uiConstants';

import type { InsightsLens } from '../../../redux/slices/InsightsSlice';

// Kept out of useFarmsNavSync so it can be unit-tested without pulling in the
// service layer (axios) that the hook's data fetching depends on.

// Old "summary" bookmarks/shares are treated as invalid so they fall back to
// the default lens below, rather than landing on the now-hidden tab with
// nothing visually selected (OP-2364 hid the "Summary" lens). Nutrition and
// Rotation moved to Planning (OP-2549) — useFarmsNavSync sends their old
// links there, so they're no longer Insights lenses.
const VALID_LENSES: InsightsLens[] = [
  INPUT_DOC_LENS_SUMMARY_2,
  INPUT_DOC_LENS_ANALYSIS,
  INPUT_DOC_LENS_MARGIN_BREAK_EVEN,
  INPUT_DOC_LENS_CASHFLOW,
];

// The `?lens=` URL param, resolved to the lens the reducer holds. The Gross
// Margin lens was renamed to Margin & break-even (OP-2393); its old URL value
// still resolves so existing bookmarks and shared links keep working.
export const resolveInsightsLensParam = (param: string | null): InsightsLens => {
  const lens =
    param === INPUT_DOC_LENS_GROSS_MARGIN_LEGACY
      ? INPUT_DOC_LENS_MARGIN_BREAK_EVEN
      : param;
  return VALID_LENSES.includes(lens as InsightsLens)
    ? (lens as InsightsLens)
    : INPUT_DOC_LENS_SUMMARY_2;
};
